export const ErrorRegistry = {
	USER_NOT_FOUND: {
		message: "User not found",
		statusCode: 404,
		public: true,
	},
	USER_TOKEN_NOT_FOUND: {
		message: "Could not find verification token",
		statusCode: 404,
		public: true,
	},
	QUIZ_ID_INVALID: {
		message: "URL path contains a malformed segment. Requires valid quiz ID",
		statusCode: 400,
		public: true,
	},
	QUIZ_NO_TOKEN: {
		message: "Missing token, cannot verify access to this quiz",
		statusCode: 401,
		public: true,
	},
	NOTE_ID_INVALID: {
		message: "URL path contains a malformed segment. Requires valid note ID",
		statusCode: 400,
		public: true,
	},
	NOTE_NO_TOKEN: {
		message: "Missing token, cannot verify access to this note",
		statusCode: 401,
		public: true,
	},
	GIST_ID_INVALID: {
		message: "URL path contains a malformed segment. Requires valid gist ID",
		statusCode: 400,
		public: true,
	},
	GIST_NO_TOKEN: {
		message: "Missing token, cannot verify access to this gist",
		statusCode: 401,
		public: true,
	},
	FLASHCARD_SET_ID_INVALID: {
		message:
			"URL path contains a malformed segment. Requires valid flashcard set ID",
		statusCode: 400,
		public: true,
	},
	FLASHCARD_SET_NO_TOKEN: {
		message: "Missing token, cannot verify access to this flashcard set",
		statusCode: 401,
		public: true,
	},
	FOLDER_ID_INVALID: {
		message: "URL path contains a malformed segment. Requires valid folder ID",
		statusCode: 400,
		public: true,
	},
	STRIPE_NO_SESSION_ID: {
		message: "Session ID is required",
		statusCode: 400,
		public: true,
	},
	STRIPE_SESSION_ID_INVALID: {
		message: "Invalid session ID",
		statusCode: 400,
		public: true,
	},
	STRIPE_NO_CUSTOMER: {
		message: "Customer information was not found in the session",
		statusCode: 400,
		public: true,
	},
	STRIPE_INVALID_CUSTOMER: {
		message: "Customer information was not found in the session",
		statusCode: 400,
		public: true,
	},
	STRIPE_CUSTOMER_DELETED: {
		message: "Customer information was deleted",
		statusCode: 409,
		public: true,
	},
	EMAIL_INVALID_TOKEN: {
		message: "Token was in an invalid format. Try submitting again",
		statusCode: 400,
		public: true,
	},
} as const;

export type ErrorCode = keyof typeof ErrorRegistry;
